export const modalOneDatas = [
    {
      iconClassName: "fa-spin fa-cog",
      tittle: "2FA Authenticator",
      description: "Obtain codes from a authy/google authenticator/ios 15 etc.",
    },
    {
      iconClassName: "fa-comments",
      tittle: "SMS",
      description:
        "The backup login method will be sent to you via SMS if you require it.",
    }
  ]